var VIDEOS_URLS = {
    student: 'https://www.youtube.com/embed/8z6wKVKruyI',
    intro: 'https://www.youtube.com/embed/DslTH_Nm-kg',
    reports: 'https://www.youtube.com/embed/A21rNNK0C1s',
};
var GET_STARTED_URLS = {
    help: 'https://help.happynumbers.com/en',
    videos: VIDEOS_URLS,
    faq: {
        howHNTeach: 'https://help.happynumbers.com/en/articles/3811654-how-does-happy-numbers-teach',
        howStudentAccountWorks: 'https://help.happynumbers.com/en/articles/3139955-what-happens-after-my-students-logged-in',
        firstRun: 'https://help.happynumbers.com/en/articles/5051446-first-run-placement-test-to-create-a-learning-pathway',
        howTeacherAccountWorks: 'https://help.happynumbers.com/en/articles/5595668-where-can-i-find-my-class-reports',
        reviewAndResetTestResults: 'https://help.happynumbers.com/en/articles/3289390-how-do-i-review-and-reset-the-placement-test-results',
        changeAssignment: 'https://help.happynumbers.com/en/articles/3289456-how-do-i-change-an-assignment',
        setUpMidYearTest: 'https://help.happynumbers.com/en/articles/5055691-set-up-your-mid-year-test-with-happy-numbers',
        addMoreStudents: 'http://help.happynumbers.com/en/articles/3935146-how-can-i-edit-my-class-roster',
        addAnotherClass: 'https://help.happynumbers.com/en/articles/861668-can-i-add-more-than-one-class',
        setUpDevices: 'https://help.happynumbers.com/en/articles/3915619-how-to-set-up-devices',
        createShortcutOnIpad: 'https://help.happynumbers.com/en/articles/861606-how-do-i-create-a-shortcut-to-happy-numbers-on-ipad',
        switchLanguage: 'https://help.happynumbers.com/en/articles/861591-how-do-i-assign-different-languages-to-certain-students',
        adjustStudentLevel: 'https://help.happynumbers.com/en/articles/3289456-how-do-i-adjust-an-individual-student-s-level',
    },
};
export { GET_STARTED_URLS };
